module.exports = __webpack_public_path__ + "img/serveObj1.89dadbe3.png";